import React, { useEffect, useState } from "react";
import EditModal from "../../components/form_elements/edit-modal";
import BeneficiaryForm from "./beneficiary-form";
import * as Yup from 'yup';
import { OptionalString, RequiredNumber, RequiredString, RequiredDate,OptionalNumber, OptionalBoolean } from "../../components/form_elements/form-validators";
import useMsalApi from "../../components/use-msal-api";
import { createGuid, getExistingContact, isQualifiedDependent } from "../../components/contact-builder";
import { useDispatch, useSelector } from "react-redux";
import { updateDependent } from "../../redux/actions/enrollments-actions";

const BeneficiaryEdit = ({beneficiaries, setBeneficiaries, beneficiary, setBeneficiary, show, setShow, isEmployee, setIsEmployee }) => {
    const [submitting, setSubmitting] = useState();
    const [callApi] = useMsalApi();
    const onClose = () => {setBeneficiary({});}
    const [relationships, setRelationships] = useState();
    const [countries, setCountries] = useState();
    const enrollments = useSelector(s => s.enrollments);
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        firstName: RequiredString("Required"),
        lastName: RequiredString("Required"),
        relationship: RequiredString("Required"),
        percentage: RequiredNumber("Required").max(100).min(1),
        type: RequiredNumber("Required"),
        birthdate: RequiredDate("Required").max(new Date(), 'Invalid Date'),
        genderId:  RequiredString("Required"),
        addressLine1:RequiredString("Required"),
        postalCode:RequiredString("Required"),
        city:RequiredString("Required"),
        state:OptionalString().test("", "Required", (item, ctx) => { 
            return ctx.parent.country === "US" && (item === null || item === "") && !ctx.parent.isEmployee ? false : true
        }),
        region:OptionalString("Required").test("", "Required", (item, ctx) => { 
            return ctx.parent.country !== "US" && (item === null || item === "") && !ctx.parent.isEmployee ? false : true
        }),
        country:OptionalString("Required").when("isEmployee", { is: false, then: RequiredString("Required") }),
        ssn: OptionalString().test("", "SSN must be 9 digits", (item) => item ? item.length === 11 : true)
            .test("", "Not a valid SSN", (item) =>  item ? /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/.test(item) : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "123-45-6789" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "111-11-1111" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "222-22-2222" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "333-33-3333" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "444-44-4444" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "555-55-5555" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "777-77-7777" : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "888-88-8888" : true),
        selectedEmployee: OptionalString(),
        isEmployee: OptionalBoolean(),
    });

    const getCountries = async () => {
        const results = await callApi("Lookup/Countries", "GET");
        if(!results.error){
            setCountries(results);
        }
    }


    const onSubmit = async(formData) => {
        console.log('formData',formData);
        let contactId = formData.id
        if(!contactId){
            contactId = contactId ?? createGuid();
        }
        setSubmitting(true);
        let contact = getExistingContact(enrollments.contacts, formData.lastName, formData.firstName, formData.birthdate);
        if(!contact)
                contact = {
                id: contactId,
                firstName: formData.firstName,
                lastName: formData.lastName,
                birthdate: formData.birthdate,
        };
        contact.gender = {id: formData.genderId, name: enrollments.genders.find(s => s.id === formData.genderId)?.name};
        contact.ssn = formData.ssn;
        contact.relationship = {id: formData.relationship, name: relationships.find(s => s.id === formData.relationship).name};
        contact.type = formData.type;
        contact.percentage = formData.percentage;
        contact.address = { 
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
            city: formData.city,
            state: formData.country === "US" ? formData.state : null,
            region:  formData.country === "US" ? null : formData.region,
            postalCode: formData.postalCode,
            country: formData.country
        };
        contact.isEmployee = formData.isEmployee
        let filtered = beneficiaries.filter(s=>s.id !== contact.id);
        filtered.push(contact);
        setBeneficiaries(filtered);
           
        setSubmitting(false);
        setShow(false);
    }

    const onError = (errors, e) => {
        console.log(errors);
    }
    
    useEffect(() => {
        const getRelationships = async () => {
            var results = await callApi("lookup/BeneficiaryRelationships", "GET");
            if(!results.error){
                setRelationships(results);
            }
        }
        getRelationships();
        getCountries();
    }, []);


    return(
        <EditModal 
            title="Beneficiary" 
            schema={validationSchema}  
            onError={onError} 
            onSubmit={onSubmit} 
            show={show} 
            setShow={setShow} 
            submitting={submitting} 
            onClose={onClose}
            focusElement="input"
            
        >
            <BeneficiaryForm beneficiary={beneficiary} show={show} relationships={relationships} countries={countries} isEmployee={isEmployee} setIsEmployee={setIsEmployee}/>
        </EditModal>
    )
}

export default BeneficiaryEdit